var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.667 60.612c0 7.407-1.627 14.427-4.554 20.727-7.82 16.9-24.926 28.607-44.78 28.607-19.846 0-36.953-11.707-44.78-28.607C12.627 75.04 11 68.02 11 60.612 11 33.36 33.08 11.28 60.334 11.28c27.26 0 49.333 22.08 49.333 49.333Z",
    fill: "#F0F1F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.667 28.333v55.684l-24 12.316h-25.47l-25.863-12v-72c0-.736.597-1.333 1.333-1.333h56.667v16c0 .736.597 1.333 1.333 1.333h16Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.667 28.333h-16A1.333 1.333 0 0 1 80.334 27V11l17.333 17.333Z",
    fill: "#D2D5D9"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 19.666h14.667",
    stroke: "#336FB2",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55 28.333H32.334V51h22.667V28.333Zm0 30H32.334V81h22.667V58.333Z",
    fill: "#E8E9EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65 36.333h20.667",
    stroke: "#D2D5D9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42.333h10.667",
    stroke: "#E8E9EB",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.334 65.666h16",
    stroke: "#D2D5D9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.334 71.666h21.333",
    stroke: "#E8E9EB",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m47.075 61 1.926 10.666H38.334L40.369 61h6.706Z",
    fill: "#EC856F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m49 71.666-2 6.667h-6.666l-2-6.666h10.667Z",
    fill: "#DE6A5A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.667 36.333c0 1.054-.27 1.744-.641 2.667H35.64c-.37-.923-.641-1.613-.641-2.667h16.667Z",
    fill: "#399C97"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.001 39c-1.202 3.514-4.18 6-7.666 6-3.486 0-6.465-2.487-7.667-6h15.333Z",
    fill: "#7FBEC6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.28 101.281h25c.733 0 1.333-.6 1.333-1.333v-.667h-4.626a1.34 1.34 0 0 1-1.267-.913l-4.727-14.18a1.333 1.333 0 0 0-1.266-.914H29.613l4.334 16.667c0 .74.6 1.34 1.333 1.34Z",
    fill: "#B6BABF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M84.279 93.948H38.945v8.666H84.28v-8.666Z",
    fill: "#5AB2AC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.105 83.28a49.516 49.516 0 0 1-6.494 9.586l-.96 1.08c-9.02 9.833-21.98 16-36.373 16-14.393 0-27.353-6.167-36.373-16l-.96-1.08a49.479 49.479 0 0 1-6.494-9.587h28.2c.573 0 1.08.367 1.267.913l4.727 14.18c.18.547.693.914 1.266.914h19.414a1.34 1.34 0 0 0 1.266-.914l4.727-14.18c.18-.546.693-.913 1.267-.913h25.52Z",
    fill: "#399C97"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 12.334,
    y: 3,
    width: 95.334,
    height: 105.333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_255_19371"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_255_19371",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderPlaceholder);
export default __webpack_public_path__ + "static/media/order_placeholder.c25c287c4d31923bbac54fa22db39da2.svg";
export { ForwardRef as ReactComponent };